<template>
  <v-card>
    <v-card-title
      style="
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 6"
      class="pa-0"
      color="primary"
    >
      <v-toolbar flat dark color="primary" dense>
        <v-btn icon dark @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ generateMessage('user_exchanges.create.selectedLogbook') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card-title>
    <div
      class="overflow-y-auto"
      style="padding: 48px 285px 0 0;"
      :style="{ background: $vuetify.theme.themes[theme].background }"
    >
      <v-container>
        <logbook @itemSelected="handleItemSelectedClick" />
      </v-container>
    </div>
    <div
      class="pr-2"
      style="
        top: 48px;
        width: 285px;
        overflow: hidden;
        height: calc(100% - 48px);
        left: auto;
        right: 0;
        overflow-y: scroll;
        position: fixed"
    >
      <logbook-filter />
    </div>
  </v-card>
</template>

<script>
import Logbook from '@/pages/property/logbook/Logbook';
import LogbookFilter from '@/pages/property/logbook/LogbookFilters';
import { generateMessage } from '@/utils/i18n';

export default {
  name: 'UserExchangeFormLinkLogbook',
  components: { LogbookFilter, Logbook },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
  },
  methods: {
    handleItemSelectedClick(entry) {
      this.$emit('input', entry);
    },
    generateMessage,
  },
};
</script>

<style scoped></style>
